import { trackMove } from '@otto-ec/nexus-registry/pdp/tracking';

export const trackNavigationEvent = (labelValue: 'button' | 'image' | 'headline' | 'variation') => {
    trackMove({ product_Navigation: [labelValue] });
};
